import type { DealFixedRateLoanData } from '@src/types/OTC';
import { getOtcDealRateDisplayValue } from '@src/utils/OTC/otcDealDisplayUtils';
import { InspectorNumberDisplay } from './InspectorNumberDisplay';

export const FixedRateLoanDisplay = ({ instrumentData }: { instrumentData: DealFixedRateLoanData }) => {
  const displayValue = getOtcDealRateDisplayValue(instrumentData);
  if (!displayValue) {
    return <>-</>;
  }
  return <InspectorNumberDisplay value={displayValue.value} currency={displayValue.currency} />;
};
